(() => {
  const trendFavoriteApiBase = 'https://informationcollection.benyuan1.com/api/trendFavorite'
  const normaliseApiResult = (result) => result?.data && typeof result.data === 'object' && 'success' in result.data ? result.data : result
  const isSuccess = (result) => {
    const apiResult = normaliseApiResult(result)
    return apiResult?.success === true || result?.status === 'success'
  }
  const setProgressState = (button, state) => {
    if (!(button instanceof HTMLButtonElement)) return
    button.dataset.progressState = state
    button.disabled = state === 'complete'
    const card = button.closest('[data-academy-card]')
    const title = card?.querySelector('h3')?.textContent?.trim() || 'this tutorial'
    const labels = {
      none: `Add ${title} to your learning list`,
      pending: `Remove ${title} from your learning list`,
      complete: `${title} is learned`
    }
    button.setAttribute('aria-label', labels[state] || labels.none)
  }
  const postProgress = async (path, body) => {
    const response = await fetch(`${trendFavoriteApiBase}/${path}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    })
    if (!response.ok) throw new Error('Learning progress request failed')
    return response.json()
  }
  const initialiseAuthPrompt = (root) => {
    const prompt = root.querySelector('[data-academy-learning-auth-prompt]')
    if (!prompt || prompt.dataset.ready === 'true') return
    prompt.dataset.ready = 'true'
    const close = () => {
      prompt.hidden = true
      prompt.setAttribute('aria-hidden', 'true')
      document.documentElement.classList.remove('academy-learning-auth-prompt-open')
    }
    prompt.querySelectorAll('[data-academy-learning-auth-prompt-close]').forEach((button) => button.addEventListener('click', close))
    prompt.addEventListener('click', (event) => {
      if (event.target === prompt || event.target.closest('[data-academy-learning-auth-prompt-close]')) close()
    })
    prompt.querySelector('[data-academy-learning-auth-prompt-continue]')?.addEventListener('click', () => {
      close()
      root.__likeShareAuth?.setTab?.('login')
      root.__likeShareAuth?.openModal?.()
    })
    prompt.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close()
    })
  }
  const openAuthModal = (root) => {
    const prompt = root.querySelector('[data-academy-learning-auth-prompt]')
    if (!prompt) return
    prompt.hidden = false
    prompt.setAttribute('aria-hidden', 'false')
    document.documentElement.classList.add('academy-learning-auth-prompt-open')
    prompt.querySelector('[data-academy-learning-auth-prompt-continue]')?.focus()
  }
  const initialiseSuccessPrompt = (root) => {
    const prompt = root.querySelector('[data-academy-learning-success-prompt]')
    if (!prompt || prompt.dataset.ready === 'true') return
    prompt.dataset.ready = 'true'
    const close = () => {
      prompt.hidden = true
      prompt.setAttribute('aria-hidden', 'true')
      document.documentElement.classList.remove('academy-learning-success-prompt-open')
    }
    prompt.querySelectorAll('[data-academy-learning-success-prompt-close]').forEach((button) => button.addEventListener('click', close))
    prompt.addEventListener('click', (event) => {
      if (event.target === prompt || event.target.closest('.academy-learning-success-prompt__backdrop')) close()
    })
    prompt.addEventListener('keydown', (event) => { if (event.key === 'Escape') close() })
    prompt.querySelector('[data-academy-learning-success-prompt-continue]')?.addEventListener('click', close)
  }
  const openSuccessPrompt = (root) => {
    const prompt = root.querySelector('[data-academy-learning-success-prompt]')
    if (!prompt) return
    prompt.hidden = false
    prompt.setAttribute('aria-hidden', 'false')
    document.documentElement.classList.add('academy-learning-success-prompt-open')
    prompt.querySelector('[data-academy-learning-success-prompt-close]')?.focus()
  }
  const initialiseTimedPrompt = (root) => {
    const prompt = root.querySelector('[data-academy-learning-timed-prompt]')
    if (!prompt || prompt.dataset.ready === 'true') return
    prompt.dataset.ready = 'true'
    const close = () => {
      prompt.hidden = true
      prompt.setAttribute('aria-hidden', 'true')
      document.documentElement.classList.remove('academy-learning-timed-prompt-open')
    }
    prompt.querySelectorAll('[data-academy-learning-timed-prompt-close]').forEach((button) => button.addEventListener('click', close))
    prompt.addEventListener('click', (event) => {
      if (event.target === prompt || event.target.closest('.academy-learning-timed-prompt__backdrop')) close()
    })
    prompt.addEventListener('keydown', (event) => { if (event.key === 'Escape') close() })
    window.setTimeout(() => {
      prompt.hidden = false
      prompt.setAttribute('aria-hidden', 'false')
      document.documentElement.classList.add('academy-learning-timed-prompt-open')
      prompt.querySelector('[data-academy-learning-timed-prompt-close]')?.focus()
    }, 10000)
  }
  const initialiseProgress = (root) => {
    if (root.dataset.academyProgressReady === 'true') return
    root.dataset.academyProgressReady = 'true'
    initialiseAuthPrompt(root)
    initialiseSuccessPrompt(root)
    if (root.id.startsWith('NailAcademy-')) initialiseTimedPrompt(root)
    const buttons = [...root.querySelectorAll('[data-academy-progress]')]
    const customerId = root.dataset.customerId
    const customerName = root.dataset.customerName
    const customerEmail = root.dataset.customerEmail
    const loggedIn = root.dataset.customerLoggedIn === 'true' && Boolean(customerId)
    if (loggedIn && buttons.length) {
      buttons.forEach((button) => { button.disabled = true })
      postProgress('list', { user_id: customerId, category: 'all', type: 2 })
        .then((result) => {
          const apiResult = normaliseApiResult(result)
          if (!isSuccess(result) || !Array.isArray(apiResult?.data)) return
          const progressByTrendId = new Map(apiResult.data.map((item) => [String(item.trend_id), Number(item.learn_status) === 1 ? 'complete' : 'pending']))
          buttons.forEach((button) => setProgressState(button, progressByTrendId.get(button.closest('[data-academy-card]')?.dataset.trendId) || 'none'))
        })
        .catch(() => {})
        .finally(() => buttons.forEach((button) => { button.disabled = button.dataset.progressState === 'complete' }))
    }
    root.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-academy-progress]') : null
      if (!(button instanceof HTMLButtonElement) || !root.contains(button)) return
      event.preventDefault()
      event.stopPropagation()
      if (!loggedIn) { openAuthModal(root); return }
      if (button.disabled) return
      const card = button.closest('[data-academy-card]')
      const trendId = card?.dataset.trendId
      const title = card?.dataset.trendTitle
      const category = card?.dataset.trendCategory
      if (!trendId || !title || !category) return
      const currentState = button.dataset.progressState || 'none'
      if (currentState === 'complete') return
      if (currentState === 'none') {
        const matchingButtons = [...root.querySelectorAll('[data-academy-card]')]
          .filter((academyCard) => academyCard.dataset.trendId === trendId)
          .map((academyCard) => academyCard.querySelector('[data-academy-progress]'))
          .filter((academyButton) => academyButton instanceof HTMLButtonElement)
        matchingButtons.forEach((academyButton) => {
          setProgressState(academyButton, 'pending')
          academyButton.disabled = true
        })
        openSuccessPrompt(root)
        postProgress('favorite', {
          user_id: customerId,
          user_name: customerName,
          email: customerEmail,
          trend_id: trendId,
          category,
          title,
          type: 2
        })
          .then((result) => {
            if (!isSuccess(result)) throw new Error('Learning progress request was not successful')
          })
          .catch(() => {
            matchingButtons.forEach((academyButton) => setProgressState(academyButton, 'none'))
          })
          .finally(() => {
            matchingButtons.forEach((academyButton) => { academyButton.disabled = academyButton.dataset.progressState === 'complete' })
          })
        return
      }
      button.disabled = true
      try {
        const result = await postProgress('unfavorite', {
          user_id: customerId,
          user_name: customerName,
          email: customerEmail,
          trend_id: trendId,
          type: 2
        })
        if (isSuccess(result)) {
          const nextState = 'none'
          root.querySelectorAll('[data-academy-card]').forEach((academyCard) => {
            if (academyCard.dataset.trendId === trendId) setProgressState(academyCard.querySelector('[data-academy-progress]'), nextState)
          })
        }
      } catch (_) {
        // Keep the server-confirmed state when the request fails.
      } finally {
        button.disabled = button.dataset.progressState === 'complete'
      }
    })
  }
  const initialiseList = (list) => {
    if (list.dataset.academyReady) return
    list.dataset.academyReady = 'true'
    const tabs = list.querySelectorAll('[data-academy-tab]')
    const mobileTabs = list.querySelector('[data-academy-mobile-tabs]')
    const mobileTrigger = list.querySelector('[data-academy-mobile-trigger]')
    const mobileOptions = list.querySelector('[data-academy-mobile-options]')
    const mobileCurrentLabel = list.querySelector('[data-academy-mobile-label]')
    const mobileOptionButtons = list.querySelectorAll('[data-academy-mobile-option]')
    const cards = list.querySelectorAll('[data-academy-card]')
    const previous = list.querySelector('[data-academy-previous]')
    const next = list.querySelector('[data-academy-next]')
    const carousel = list.querySelector('[data-academy-carousel]')
    const showAll = list.hasAttribute('data-academy-show-all')
    let activeCards = [...cards]
    let page = 0
    const pageSize = () => {
      if (showAll) return Math.max(1, activeCards.length)
      if (window.innerWidth < 750) return Math.max(1, activeCards.length)
      return window.innerWidth < 1200 ? 3 : 4
    }
    const updateCarousel = () => {
      const size = pageSize()
      const pageCount = Math.max(1, Math.ceil(activeCards.length / size))
      page = Math.min(page, pageCount - 1)
      const visibleCards = new Set(activeCards.slice(page * size, (page + 1) * size))
      cards.forEach((card) => { card.hidden = !visibleCards.has(card) })
      if (carousel) carousel.classList.toggle('has-multiple-pages', pageCount > 1)
      if (previous) previous.disabled = page === 0
      if (next) next.disabled = page === pageCount - 1
    }
    const filter = (tag) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.academyTab === tag
        tab.classList.toggle('is-active', selected)
        tab.setAttribute('aria-selected', selected ? 'true' : 'false')
      })
      mobileOptionButtons.forEach((option) => {
        const selected = option.dataset.academyMobileOption === tag
        option.classList.toggle('is-active', selected)
        if (selected && mobileCurrentLabel) mobileCurrentLabel.textContent = option.textContent
      })
      activeCards = tag === 'all' ? [...cards] : [...cards].filter((card) => card.dataset.tags.split('|').includes(tag))
      page = 0
      updateCarousel()
    }
    tabs.forEach((tab) => tab.addEventListener('click', () => filter(tab.dataset.academyTab)))
    if (mobileTrigger && mobileOptions) {
      mobileTrigger.addEventListener('click', () => {
        const open = mobileTrigger.getAttribute('aria-expanded') === 'true'
        mobileTrigger.setAttribute('aria-expanded', open ? 'false' : 'true')
        mobileTabs.classList.toggle('is-open', !open)
        mobileOptions.hidden = open
      })
      mobileOptionButtons.forEach((option) => option.addEventListener('click', () => {
        filter(option.dataset.academyMobileOption)
        mobileTrigger.setAttribute('aria-expanded', 'false')
        mobileTabs.classList.remove('is-open')
        mobileOptions.hidden = true
      }))
    }
    if (previous) previous.addEventListener('click', () => { page -= 1; updateCarousel() })
    if (next) next.addEventListener('click', () => { page += 1; updateCarousel() })
    if (tabs.length) filter(tabs[0].dataset.academyTab)
    else updateCarousel()
  }
  const initialise = (section) => {
    initialiseProgress(section)
    section.querySelectorAll('[data-academy-list]').forEach(initialiseList)
  }
  const mount = (root = document) => root.querySelectorAll('[data-nail-academy]').forEach(initialise)
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => mount()) : mount()
  document.addEventListener('shopify:section:load', (event) => mount(event.target))
})()
